import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';

import { usePageCRUDActions } from '@mm/state/actions/PageCRUDActions';
import { CloseIcon, DoneIcon } from '@mm/icons/general';

import { successToast } from '../../../../../../common/helpers/toast';
import { colors } from '../../../../beta/styles/colors';
import './DialogueNameForm.pcss';

type Props = {
  className?: string;
  name?: string;
  dialogueId: string | number;
  botId: number;
  onCancel?: () => void;
  onSuccess?: () => void;
  onError?: () => void;
};

export const DIALOGUE_MAX_NAME = 50;

export const DialogueNameForm = ({
  className,
  name,
  dialogueId,
  botId,
  onCancel,
  onSuccess = () => {},
  onError = () => {},
}: Props) => {
  const [value, setValue] = useState(name);

  const pageCRUDActions = usePageCRUDActions();

  const cn = useMemo(
    () => ({
      container: classNames(className, 'dialogue-name-form'),
    }),
    [className],
  );

  const saveName = useCallback(async () => {
    if (value?.length && dialogueId) {
      try {
        const res = await pageCRUDActions.update({
          id: dialogueId,
          botId,
          name: value,
        });
        if (res) {
          successToast('Name updated');
          onSuccess();
        }
      } catch (err) {
        onError();
      }
    }
  }, [dialogueId, value, botId]);

  return (
    <div className={cn.container}>
      <input
        className="dialogue-name-form__name-input"
        value={value}
        maxLength={DIALOGUE_MAX_NAME}
        onChange={e => setValue(e.target.value)}
        autoFocus
      />

      <div
        className={
          value?.length
            ? 'dialogue-name-form__action-icon'
            : 'dialogue-name-form__action-icon--disabled'
        }
        onClick={saveName}
      >
        <DoneIcon
          style={{ height: 21, width: 21 }}
          color={value?.length ? colors.green : colors.grayLight}
        />
      </div>
      <div className="dialogue-name-form__action-icon" onClick={onCancel}>
        <CloseIcon color={colors.redLight} style={{ height: 21, width: 21 }} />
      </div>
    </div>
  );
};
